import { Injectable } from '@angular/core';
import { Centrifuge, Subscription } from 'centrifuge';

@Injectable({
  providedIn: 'root',
})
export class CentrifugeService {
  centrifuge = new Centrifuge(
    'wss://centrifuge.icibot.net/connection/websocket',
    {
      token: localStorage.getItem('centrifugeToken'),
    }
  );

  constructor() {}

  subscribeToChannel(channelName: string): Subscription {
    if (!this.centrifuge.getSubscription(channelName)) {
      return this.centrifuge.newSubscription(channelName);
    } else if (
      this.centrifuge.getSubscription(channelName) &&
      this.centrifuge.getSubscription(channelName).state !== 'subscribed'
    ) {
      return this.centrifuge.getSubscription(channelName)!;
    } else {
      return this.centrifuge.getSubscription(channelName);
    }
  }
}
